import React from 'react';
import PropTypes from 'prop-types';

import { TableCell, TableRow } from '@mui/material';

import OnDeleteIcon from '../../../icons/OnDeleteIcon';
import OnEditIcon from '../../../icons/OnEditIcon';
import { reverseFormatDate } from '../../../utils/dateFunctions';

import table from '../../../commonStyles/tables.module.css';

const SupportedJobSearchTableRow = ({
    jobSearchEntry,
    onEdit,
    onDelete,
    isDisabled,
    isDeleteDisabled
}) => {
    // RENDER
    return (
        <TableRow
            hover
            className={table.basicRowStripes}
            key={jobSearchEntry.id}
            data-testid={`table-row-${jobSearchEntry.id}`}>
            <TableCell>{reverseFormatDate(jobSearchEntry.dateApplied)}</TableCell>
            <TableCell>{jobSearchEntry.jobSectorName ?? ' - '}</TableCell>
            <TableCell>{jobSearchEntry.businessName ?? ' - '}</TableCell>
            <TableCell>{jobSearchEntry.jobTitle ?? ' - '}</TableCell>
            <TableCell>{reverseFormatDate(jobSearchEntry.interviewDate) ?? ' - '}</TableCell>
            <TableCell>{jobSearchEntry.interviewAttended}</TableCell>
            <TableCell>{jobSearchEntry.jobOffered}</TableCell>
            <TableCell>{jobSearchEntry.jobAccepted}</TableCell>
            <TableCell>
                <OnEditIcon onEdit={() => onEdit(jobSearchEntry)} active={!isDisabled} />
            </TableCell>
            <TableCell>
                <OnDeleteIcon
                    onDelete={() => onDelete(jobSearchEntry.id)}
                    active={!isDeleteDisabled}
                />
            </TableCell>
        </TableRow>
    );
};

SupportedJobSearchTableRow.propTypes = {
    jobSearchEntry: PropTypes.object.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    isDeleteDisabled: PropTypes.bool.isRequired
};

export default SupportedJobSearchTableRow;
